function Clickable(callback) {
  this.name='clickable';
   this.action= callback;
}

export {Clickable};
